module.exports = __webpack_public_path__ + "static/react1-87c77ee3060b37dc30884b0b000ff9ca.jpeg";